export const resumeHref = "/Muhammad-Abdullah-Resume.pdf";
export const resumeDownload = "Muhammad-Abdullah-Resume.pdf";

export const linkedIn = "https://linkedin.com/in/muhammad-abdullah-ab5062241";
export const credly = "https://www.credly.com/users/muhammad-abdullah.250a6edf";

export const email = "m.abdullahrauf1@gmail.com";
export const phone = "+92 348 427 2019";
export const phoneHref = "tel:+923484272019";
